export const getShowDetailsById = () => {
  return fetch(process.env.REACT_APP_API_URL + '/ShowCs?filter[where][externalIdC]='+process.env.REACT_APP_SHOW_ID, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }).then(response => {
    return response.json();
  });
};



// WEBPACK FOOTER //
// ./src/api/showAPI.js